import { Category } from './FilterListOfCards.types';

export const UNIQUE_FILTERS = ['minIncomeCeil'];

export const CARD_FILTERS: Category[] = ['bank', 'benefit', 'minIncomeCeil'];
